<script lang="ts" setup>

import ButtonInput from "@/components/inputs/Button.vue";
import {ref} from "vue";
import Translator from '@/utils/common/Translator'
import NamaIcon from "@/components/icons/NamaIcon.vue";

let emit = defineEmits(['onSendResetTokenClicked']);
const EMAIL = "Email";
const PHONE_NUMBER = "Phone Number";
let codeMethod = ref(EMAIL);
let phoneOrMail = ref("");
let isPhoneOrMail = ref(true);
let validationError = ref<string>("");


function handleRadioChange(event: Event) {
  const target = event.target as HTMLInputElement;
  codeMethod.value = target.value;
}

function onContinueClick() {
  if (!validateMailOrPhone())
    return;
  emit('onSendResetTokenClicked', phoneOrMail.value, codeMethod.value === EMAIL);
}

function validateMailOrPhone(): boolean {
  isPhoneOrMail.value = Boolean(phoneOrMail.value);
  validationError.value = "";
  if (isPhoneOrMail.value && codeMethod.value === EMAIL && !isValidEmail(phoneOrMail.value)) {
    isPhoneOrMail.value = false;
    validationError.value = Translator.translate("Invalid Email")!;
    return false;
  }
  return isPhoneOrMail.value;
}

function isValidEmail(email: string): boolean {
  const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
</script>

<template>
  <div class="tw-flex tw-flex-1 tw-items-center tw-justify-center tw-px-6 tw-py-10 mobile:tw-px-5 mobile:tw-py-8">
    <div class="tw-w-full tw-max-w-[380px]">
      <h2 class="tw-m-0 tw-text-3xl tw-font-medium tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark mobile:tw-text-2xl"
          v-text="Translator.translateId('forgotPassword')"/>
      <p class="tw-mt-1 tw-mb-7 tw-text-sm tw-text-namaFontColor-header-light dark:tw-text-namaFontColor-header-dark"
         v-text="Translator.translateId('selectSendCodeMethod')"/>
      <div class="tw-mb-4 tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2">
        <label for="email-code-method"
               class="tw-flex tw-min-h-[44px] tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark">
          <input id="email-code-method" type="radio" name="send-code-method" :value="EMAIL"
                 :checked="codeMethod==EMAIL" @input="handleRadioChange"
                 class="tw-size-[18px] tw-cursor-pointer tw-text-primary-light dark:tw-text-primary-dark focus:tw-ring-0"/>
          <span v-text="Translator.translateId('Email')"/>
        </label>
        <label for="phone-code-method"
               class="tw-flex tw-min-h-[44px] tw-cursor-pointer tw-items-center tw-gap-2 tw-text-sm tw-text-namaFontColor-input-light dark:tw-text-namaFontColor-input-dark">
          <input id="phone-code-method" type="radio" name="send-code-method" :value="PHONE_NUMBER"
                 :checked="codeMethod==PHONE_NUMBER" @input="handleRadioChange"
                 class="tw-size-[18px] tw-cursor-pointer tw-text-primary-light dark:tw-text-primary-dark focus:tw-ring-0"/>
          <span v-text="Translator.translateId('phoneNumber')"/>
        </label>
      </div>
      <q-input
        outlined
        dense
        input-class="nama-input-class"
        class="nama-auth-input nama-focused-input nama-field-input tw-mb-5"
        v-model="phoneOrMail"
        :placeholder="codeMethod==EMAIL?Translator.translateId('Email'):Translator.translateId('phoneNumber')"
        :error="!isPhoneOrMail"
        :hide-bottom-space="true"
        @keyup.enter="onContinueClick"
        autocomplete="off">
        <template v-slot:prepend>
          <NamaIcon v-if="codeMethod==EMAIL" default-icon="nm-email"/>
          <NamaIcon v-if="codeMethod==PHONE_NUMBER" default-icon="nm-phone_call_3059408"/>
        </template>
      </q-input>
      <ButtonInput class="nama-auth-cta" :text="Translator.translateId('Continue')" @click="onContinueClick" @keydown.enter="onContinueClick"/>
      <p v-if="validationError" role="alert"
         class="tw-mt-3 tw-mb-0 tw-text-sm tw-text-namaWarning-light dark:tw-text-namaWarning-dark"
         v-text="validationError"/>
    </div>
  </div>
</template>
